/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ApprenantRepresentantHopeGridDto } from './ApprenantRepresentantHopeGridDto';
import {
    ApprenantRepresentantHopeGridDtoFromJSON,
    ApprenantRepresentantHopeGridDtoFromJSONTyped,
    ApprenantRepresentantHopeGridDtoToJSON,
} from './ApprenantRepresentantHopeGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ApprenantRepresentantHopeGridDtoPaginatedResults
 */
export interface ApprenantRepresentantHopeGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ApprenantRepresentantHopeGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ApprenantRepresentantHopeGridDto>}
     * @memberof ApprenantRepresentantHopeGridDtoPaginatedResults
     */
    results?: Array<ApprenantRepresentantHopeGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ApprenantRepresentantHopeGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ApprenantRepresentantHopeGridDtoPaginatedResults interface.
 */
export function instanceOfApprenantRepresentantHopeGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApprenantRepresentantHopeGridDtoPaginatedResultsFromJSON(json: any): ApprenantRepresentantHopeGridDtoPaginatedResults {
    return ApprenantRepresentantHopeGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ApprenantRepresentantHopeGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApprenantRepresentantHopeGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ApprenantRepresentantHopeGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ApprenantRepresentantHopeGridDtoPaginatedResultsToJSON(value?: ApprenantRepresentantHopeGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ApprenantRepresentantHopeGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

